import { AddressBook, Phone, MapPin } from '@phosphor-icons/react'
import KioskHeader from '../../components/KioskHeader/KioskHeader'
import useKioskAutoHome from '../../hooks/useKioskAutoHome'

const CONTACTS = [
  { name: 'Management Office', phone: '+60 82 000 001', location: 'Level G, Admin Office' },
  { name: 'Security Counter', phone: '+60 82 000 002', location: 'Main Lobby' },
  { name: 'Facilities Team', phone: '+60 82 000 003', location: 'Maintenance Office' },
  { name: 'Emergency Contact', phone: '999', location: 'For emergency use only' },
]

export default function DirectoryPage() {
  useKioskAutoHome()

  return (
    <main className="kiosk-page">
      <div className="app-container kiosk-container">
        <KioskHeader title="Contact Directory" subtitle="Building and community contacts" />

        <section className="kiosk-section-card">
          <div className="kiosk-section-card__header">
            <AddressBook size={30} />
            <div>
              <h1>Contact Directory</h1>
              <p>Find important contacts for assistance and building support.</p>
            </div>
          </div>

          <div className="kiosk-list kiosk-list--two">
            {CONTACTS.map((contact) => (
              <article className="kiosk-list-card" key={contact.name}>
                <strong>{contact.name}</strong>
                <div><Phone size={18} /> {contact.phone}</div>
                <div><MapPin size={18} /> {contact.location}</div>
              </article>
            ))}
          </div>
        </section>
      </div>
    </main>
  )
}
